import React from 'react';

/**
 * Bir alt bileşen render sırasında hata fırlatırsa tüm uygulamanın beyaz ekrana
 * düşmesini engeller. Hatayı ekranda gösterir (destek için ekran görüntüsü alınabilir)
 * ve "Yenile" ile sayfayı yeniden yükleme imkanı verir.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Konsola da yaz (uzak log/inceleme için)
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Render hatası:', error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.hasError) {
      const { error, info } = this.state;
      const mesaj = (error && (error.message || String(error))) || 'Bilinmeyen hata';
      const stack = (info && info.componentStack) || (error && error.stack) || '';
      return (
        <div style={{ minHeight: '100vh', background: '#0f172a', color: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'Arial, sans-serif' }}>
          <div style={{ maxWidth: 720, width: '100%', background: '#1e293b', border: '1px solid #334155', borderRadius: 16, padding: 24 }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
            <h1 style={{ fontSize: 20, fontWeight: 800, margin: '0 0 6px' }}>{this.props.baslik || 'Bir hata oluştu'}</h1>
            <p style={{ color: '#f87171', fontWeight: 700, margin: '0 0 12px', wordBreak: 'break-word' }}>{mesaj}</p>
            <pre style={{ background: '#0b1220', border: '1px solid #334155', borderRadius: 8, padding: 12, fontSize: 11, color: '#94a3b8', maxHeight: 220, overflow: 'auto', whiteSpace: 'pre-wrap' }}>{stack}</pre>
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button onClick={() => window.location.reload()} style={{ padding: '10px 18px', background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>Yenile</button>
              <button onClick={() => { window.history.length > 1 ? window.history.back() : (window.location.href = '/'); }} style={{ padding: '10px 18px', background: '#334155', color: '#e2e8f0', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>Geri Dön</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
